module.exports = __webpack_public_path__ + "media/images/icons/filled/build-480cda1dcb5fe7686187889ba08bc169.svg";